import React from 'react'

function Subcategoria(props) {
    return (

        <span id={props.id} className='cardlist-module' onClick={props.onClick} >{props.nombre}</span>

    )
}

export { Subcategoria };